// extracted by mini-css-extract-plugin
export default {"fwTooltip":"fwTooltip_fwTooltip__wuoX8","fwTooltip-item":"fwTooltip_fwTooltip-item__NP6gS"};